(function () {
  document.querySelectorAll('[data-cd-timer]').forEach(function (root) {
      var el = root;
      if (!el) return;
  
      var mode = el.dataset.mode;
      var showDays = el.dataset.showDays === 'true';
      var labels = {
        days: el.dataset.labelDays,
        hours: el.dataset.labelHours,
        mins: el.dataset.labelMins,
        secs: el.dataset.labelSecs
      };
      var expiredText = el.dataset.expiredText || 'This offer has ended';
      var storageKey = 'cd-evergreen-' + el.dataset.sectionId;
  
      function pad(n) { return (n < 10 ? '0' : '') + n; }
  
      function getTargetTime() {
        if (mode === 'evergreen') {
          var durationMs =
            (parseInt(el.dataset.durationHours, 10) || 0) * 3600000 +
            (parseInt(el.dataset.durationMinutes, 10) || 0) * 60000;
          var start = parseInt(localStorage.getItem(storageKey), 10);
          var now = Date.now();
          // First visit, or the previous countdown already finished -> (re)start it
          if (!start || now - start >= durationMs) {
            start = now;
            try { localStorage.setItem(storageKey, String(start)); } catch (e) {}
          }
          return start + durationMs;
        }
        // Fixed end-date mode. Date entered in store local time.
        var date = el.dataset.endDate;
        var time = el.dataset.endTime || '23:59';
        if (!date) return null;
        var target = new Date((date + 'T' + time).replace(/-/g, '/').replace('T', ' '));
        return isNaN(target.getTime()) ? null : target.getTime();
      }
  
      function unit(value, label) {
        return (
          '<div class="cd-unit"><span class="cd-num">' +
          pad(value) +
          '</span><span class="cd-label">' +
          label +
          '</span></div>'
        );
      }
  
      var colon = '<span class="cd-colon">:</span>';
  
      function render() {
        var target = getTargetTime();
        if (target === null) {
          el.innerHTML = unit(0, labels.hours) + colon + unit(0, labels.mins) + colon + unit(0, labels.secs);
          return;
        }
  
        var diff = target - Date.now();
  
        if (diff <= 0) {
          if (mode === 'evergreen') {
            // Restart the evergreen cycle on the next tick
            try { localStorage.removeItem(storageKey); } catch (e) {}
            diff = 0;
          } else {
            el.innerHTML = '<span class="cd-expired">' + expiredText + '</span>';
            clearInterval(timer);
            return;
          }
        }
  
        var totalSec = Math.floor(diff / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        var secs = totalSec % 60;
  
        var html = '';
        if (showDays) {
          html += unit(days, labels.days) + colon;
        } else {
          hours += days * 24; // roll days into the hours column
        }
        html += unit(hours, labels.hours) + colon + unit(mins, labels.mins) + colon + unit(secs, labels.secs);
        el.innerHTML = html;
      }
  
      render();
      var timer = setInterval(render, 1000);
  });
})();
